var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-xs":""}},[_c('div',[_vm._v("この機能にアクセスする権限がありません")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }